module.exports = __webpack_public_path__ + "img/guernsey.57f9f52c.svg";